import { Button } from "../../../../components/design-system";
import { COPY } from "../copy";

import { BudgetLimitingTag } from "./BudgetLimitingTag";
import { PreferredStoreTypePill } from "./PreferredStoreTypePill";

type PreferredStoreTypesCardProps = {
  selectedStoreTypes: string[];
  onSelectStoreTypes: () => void;
  budgetConstrained?: boolean;
};

export function PreferredStoreTypesCard({
  selectedStoreTypes,
  onSelectStoreTypes,
  budgetConstrained = false,
}: PreferredStoreTypesCardProps) {
  const hasSelection = selectedStoreTypes.length > 0;

  return (
    <section className="bg-fs-surface-primary rounded-lg border border-[#dfe0e1] p-6">
      <h3 className="text-[20px] leading-[28px] font-medium text-[#333]">
        Preferred store types
      </h3>
      <p className="mt-1 max-w-[600px] text-sm leading-5 text-[#757575]">
        Choose which store types to prioritize. We&apos;ll spend your budget
        more aggressively to reach retailers in those store types, which may
        result in a higher average cost per click.{" "}
        <button type="button" className="underline">
          Learn more
        </button>
      </p>
      <div className="mt-6">
        {hasSelection ? (
          <div className="space-y-3">
            <div className="flex flex-wrap gap-2">
              {selectedStoreTypes.map((storeType) => (
                <PreferredStoreTypePill key={storeType} label={storeType} />
              ))}
            </div>
            <button
              type="button"
              className="text-sm text-[#333] underline"
              onClick={onSelectStoreTypes}
            >
              Edit store types
            </button>
          </div>
        ) : (
          <Button variant="secondary" onClick={onSelectStoreTypes}>
            + Select store types
          </Button>
        )}
      </div>
      {budgetConstrained && hasSelection ? (
        <div className="mt-4">
          <BudgetLimitingTag tooltip={COPY.settings.preferredStoreTypes} />
        </div>
      ) : null}
    </section>
  );
}
